export class SystemModel {
  public appName: string;

  public version: string;

  constructor(data: Partial<SystemModel> = {}) {
    this.appName = data.appName ?? null;
    this.version = data.version ?? null;
  }
}
